<script>
  import { imageStore, editStore } from '../stores';
  import { goToHistoryItem } from '../utils/editUtils';
  import { constructUrl } from '../utils/apiClient';
  function getOptionSummary(feature, settings) {
    if (!feature || !settings) return '';
    switch (feature.id) {
      case 'style_transform':
      case 'advanced_style_transform':
        return settings.selectedStyle ? `(${settings.selectedStyle})` : '';
      case 'replace_background':
        return settings.selectedBackground ? `(${settings.selectedBackground})` : '';
      case 'search_replace':
        return settings.searchReplacePrompt ? `(${settings.searchReplacePrompt})` : '';
      case 'outpaint':
        if (settings.outpaintSettings) {
          const { left, right, up, down, selectedPreset } = settings.outpaintSettings;
          if (selectedPreset && selectedPreset !== 'custom') {
            return `(${selectedPreset})`;
          }
          return `(L:${left}, R:${right}, U:${up}, D:${down})`;
        }
        return '';
      case 'inpaint':
        return settings.inpaintSettings?.prompt ? `(${settings.inpaintSettings.prompt})` : '';
      case 'erase_object':
        return settings.eraseObjectSeed !== undefined ? `(seed:${settings.eraseObjectSeed})` : '';
      default:
        return '';
    }
  }
</script>

<div class="history-area">
  {#if $imageStore.uploadedImageUrl}
    <div class="history-item">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
      <img
        src={constructUrl($imageStore.uploadedImageUrl)}
        alt="original"
        class:selected={$editStore.currentEditIndex === -1}
        on:click={() => goToHistoryItem(-1)}
      />
      <small class="history-caption">원본</small>
    </div>
  {/if}
  {#each $editStore.editHistory as item, i}
    <div class="history-item">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
      <img
        src={constructUrl(item.resultImage)}
        alt="history"
        class:selected={i === $editStore.currentEditIndex}
        on:click={() => goToHistoryItem(i)}
      />
      <small class="history-caption">{item.feature.name}<br>{getOptionSummary(item.feature, item.settings)}</small>
    </div>
  {/each}
</div>

<style>
  .history-area {
    border-bottom: 1px solid #ccc;
    overflow-y: auto;
    padding: 0.5rem;
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .history-area img {
    width: 95px;
    height: 95px;
    object-fit: cover;
    cursor: pointer;
    border: 2px solid transparent;
    border-radius: 10px;
  }
  .history-area img.selected {
    border-color: #FE6A37;
  }
  .history-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 120px;
    padding-left: 0;
  }
  .history-caption {
    font-size: 0.7rem;
    text-align: center;
    margin-top: 0.2rem;
    color: #555;
    word-break: keep-all;
    white-space: nowrap;
  }
  @media (max-width: 800px) {
    .history-area { flex-wrap: nowrap; overflow-x: auto; padding: 8px; max-height: 125px; }
    .history-item { flex-shrink: 0; }
  }
</style>